"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInterval = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var useInterval = function (milliSec, delayMilliSec) {
    if (delayMilliSec === void 0) { delayMilliSec = 0; }
    var _a = tslib_1.__read((0, react_1.useState)(0), 2), counter = _a[0], setCounter = _a[1];
    (0, react_1.useEffect)(function () {
        var intervalTimer = undefined;
        var delayTimer = setTimeout(function () {
            intervalTimer = setInterval(function () {
                setCounter(function (i) { return i + 1; });
            }, milliSec);
        }, delayMilliSec);
        return function () {
            if (intervalTimer !== undefined) {
                clearInterval(intervalTimer);
            }
            clearInterval(delayTimer);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return counter;
};
exports.useInterval = useInterval;
